import { ref as T, unref as f, computed as i, watch as g, onMounted as y, onUnmounted as D } from "vue";
import { getCanonicalLocale as _ } from "@nextcloud/l10n";
import { r as S, j as b, a as c } from "./_l10n-BaNxGGXy.mjs";
import { n as F } from "./_plugin-vue2_normalizer-Bj5bLKV4.mjs";
S(b);
/**
 * @copyright Copyright (c) 2024 Ferdinand Thiessen <opensource@fthiessen.de>
 *
 * @author Ferdinand Thiessen <opensource@fthiessen.de>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
const I = {
  long: c("a few seconds ago"),
  short: c("seconds ago"),
  // FOR TRANSLATORS: Shorter version of 'a few seconds ago'
  narrow: c("sec. ago")
  // FOR TRANSLATORS: If possible in your language an even shorter version of 'a few seconds ago'
};
function N(a = Date.now(), e = {}) {
  const r = T(Date.now());
  let n = null;
  const d = T({
    timeStyle: "medium",
    dateStyle: "short",
    relativeTime: "long",
    ignoreSeconds: !1,
    ...f(e)
  }), o = i(() => ({ ...f(e), ...d.value })), v = i(() => new Date(f(a))), h = i(() => new Intl.DateTimeFormat(_(), o.value.format).format(v.value)), M = i(() => {
    if (o.value.relativeTime !== !1) {
      const t = new Intl.RelativeTimeFormat(_(), { numeric: "auto", style: o.value.relativeTime }), m = (v.value - r.value) / 1e3;
      if (Math.abs(m) <= 90)
        return o.value.ignoreSeconds ? I[o.value.relativeTime] : t.format(Math.round(m), "second");
      const l = m / 60;
      if (Math.abs(l) <= 90)
        return t.format(Math.round(l), "minute");
      const u = l / 60;
      if (Math.abs(u) <= 24)
        return t.format(Math.round(u), "hour");
      const s = u / 24;
      if (Math.abs(s) <= 6)
        return t.format(Math.round(s), "day");
      const p = s / 7;
      if (Math.abs(p) <= 4)
        return t.format(Math.round(p), "week");
      const w = s / 30;
      return Math.abs(w) <= 12 ? t.format(Math.round(w), "month") : t.format(Math.round(s / 365), "year");
    }
    return h;
  });
  return g([o], (t) => {
    window.clearInterval(n), n = void 0, t.relativeTime && (n = window.setInterval(() => {
      r.value = /* @__PURE__ */ new Date();
    }, 1e3));
  }), y(() => {
    o.value.relativeTime !== !1 && (n = window.setInterval(() => {
      r.value = /* @__PURE__ */ new Date();
    }, 1e3));
  }), D(() => {
    window.clearInterval(n);
  }), {
    formattedTime: M,
    formattedFullTime: h,
    options: d
  };
}
const C = {
  name: "NcDateTime",
  props: {
    /**
     * The timestamp to display, either an unix timestamp (in milliseconds) or a Date object
     */
    timestamp: {
      type: [Date, Number],
      required: !0
    },
    /**
     * The format used for displaying, or if relative time is used the format used for the title (optional)
     *
     * @type {Intl.DateTimeFormatOptions}
     */
    format: {
      type: Object,
      default: () => ({ timeStyle: "medium", dateStyle: "short" })
    },
    /**
     * Wether to display the timestamp as time from now (optional)
     *
     * - `false`: Disable relative time
     * - `'long'`: Long text, like *2 seconds ago* (default)
     * - `'short'`: Short text, like *2 sec. ago*
     * - `'narrow'`: Even shorter text (same as `'short'` on some languages)
     */
    relativeTime: {
      type: [Boolean, String],
      default: "long",
      validator: (a) => a === !1 || ["long", "short", "narrow"].includes(a)
    },
    /**
     * Ignore seconds when displaying the relative time and just show `a few seconds ago`
     */
    ignoreSeconds: {
      type: Boolean,
      default: !1
    }
  },
  setup(a) {
    const e = i(() => a.timestamp), { formattedTime: r, formattedFullTime: n } = N(e, a);
    return {
      formattedTime: r,
      formattedFullTime: n
    };
  }
};
var O = function() {
  var e = this, r = e._self._c;
  return r("span", { staticClass: "nc-datetime", attrs: { "data-timestamp": e.timestamp, title: e.formattedFullTime } }, [e._v(e._s(e.formattedTime))]);
}, j = [], k = /* @__PURE__ */ F(
  C,
  O,
  j,
  !1,
  null,
  null,
  null,
  null
);
const z = k.exports;
export {
  z as N,
  N as u
};
